
import { defineComponent } from 'vue'

import { shortenLargeNumber } from '~/utils/string'

export default defineComponent({
  name: 'ChartStat',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLargeNumber() {
      if (typeof this.value === 'string') {
        return parseInt(this.value) > 1000
      }
      return this.value > 1000
    }
  },
  methods: {
    shortenLargeNumber
  }
})
